import React from "react";
import { connect } from "react-redux";
import "./_Gallery.scss";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import ImageGallery from "react-image-gallery";
import slugify from "slugify";

class GalleryNecklace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currentImageIndex: 0,
    };
    this.ImageGalleryRef = React.createRef();
  }

  renderCollectionGalleryButton = (collectionItem) => {
    if (collectionItem && collectionItem.length) {
      if (
        collectionItem[0].galleryImageList &&
        collectionItem[0].galleryImageList.length
      ) {
        const galleryButtonImage = collectionItem[0].galleryImageList[0];
        return (
          <div className="gallery-button-container">
            <img
              onClick={() => this.onPress()}
              src={galleryButtonImage.url}
              className="gallery-button-image"
              alt={galleryButtonImage.title}
            />
          </div>
        );
      }
    }
  };

  renderCollectionGallery = (collectionItem) => {
    if (collectionItem && collectionItem.length) {
      if (
        collectionItem[0].galleryImageList &&
        collectionItem[0].galleryImageList.length
      ) {
        const galleryImages = [];
        for (let i = 0; i < collectionItem[0].galleryImageList.length; i++) {
          galleryImages.push({
            original: collectionItem[0].galleryImageList[i].url,
            fullscreen: collectionItem[0].galleryImageList[i].url,
            description: collectionItem[0].galleryImageList[i].title,
          });
        }
        return (
          <ImageGallery
            ref={this.ImageGalleryRef}
            items={galleryImages}
            additionalClass="image-gallery-item"
            showFullscreenButton={false}
            showPlayButton={false}
            showThumbnails={false}
          />
        );
      }
    }
  };

  onPress = () => {
    const imageGallery = this.ImageGalleryRef.current;
    imageGallery.fullScreen();
  };

  render() {
    const { collectionsList, history } = this.props;
    const currentCollection = history
      ? queryString.parse(history.location.search).collection
      : null;
    let collection = null;
    if (
      collectionsList &&
      collectionsList.items &&
      collectionsList.items.length &&
      currentCollection
    ) {
      collection = collectionsList.items.filter((item) => {
        return slugify(item.title) === currentCollection;
      });
    }
    return (
      <div className="gallery gallery-necklace">
        {this.renderCollectionGalleryButton(collection)}
        {this.renderCollectionGallery(collection)}
      </div>
    );
  }
}

const mapStateToProps = ({ collection, necklace }) => {
  const { collectionsList } = collection;
  const { activeNecklace } = necklace;

  return {
    activeNecklace,
    collectionsList,
  };
};

export default connect(mapStateToProps, {})(withRouter(GalleryNecklace));
